var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verification scrollable -y"},[_c('div',{staticClass:"page-wrapper"},[(!_vm.agreeToBeginVerification)?_c('prompt-touch-to-proceed',{on:{"onTouchScreen":_vm.beginVerification}}):_c('verification-page')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37269b34","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Verification.vue
// module id = 295
// module chunks = 1